import { initializeNavigation } from './modules/navigation.js';

document.documentElement.classList.add('js');

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeNavigation);
} else {
  initializeNavigation();
}

